import { IconWrapper, NoteText, Wrapper } from './InfoNote.styles';
import type { InfoNoteProps } from './InfoNote.types';

export function InfoNote({ text, icon }: InfoNoteProps) {
  return (
    <Wrapper>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <NoteText>{text}</NoteText>
    </Wrapper>
  );
}
